import EmailStage from './components/EmailStage'
import StripeStage from './components/StripeStage'
import {
    PageContainer,
    PageContent,
    PageHeader,
} from 'features/common/components/mobile/Page'
import OnboardingPageHeader from './components/OnboardingHeader'

import useOnboardingPage from '../common/hooks/useEmailCode/useOnboardingPage/useOnboardingPage'

const OnboardingPage = () => {
    const {stage, onClickBack} = useOnboardingPage()

    return (
        <PageContainer>
            <PageHeader>
                <OnboardingPageHeader onClickBack={onClickBack} />
            </PageHeader>
            <PageContent>
                <div className="flex h-full w-full flex-1 overflow-x-hidden p-4 xs:p-10">
                    {stage === 'email' ? <EmailStage /> : null}
                    {stage === 'stripe' ? <StripeStage /> : null}
                </div>
            </PageContent>
        </PageContainer>
    )
}

export default OnboardingPage
